import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isPulsing, setIsPulsing] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Show tooltip after 3 seconds
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
    }, 3000);

    // Pulse animation every 5 seconds
    const pulseInterval = setInterval(() => {
      setIsPulsing(true);
      setTimeout(() => setIsPulsing(false), 1000);
    }, 5000);

    return () => {
      clearTimeout(tooltipTimer);
      clearInterval(pulseInterval);
    };
  }, []);

  const { i18n } = useTranslation();
  const isHebrew = i18n.language === "he";

  // Hebrew -> WhatsApp group link, otherwise -> direct chat
  const whatsappMessage = encodeURIComponent("היי מתן, הגעתי דרך האתר ואשמח לפרטים.");
  const whatsappNumber = "972505516701";
  const whatsappUrl = isHebrew
    ? "https://chat.whatsapp.com/LGPI6BAwYrS5M5kGSiNgLQ"
    : i18n.language === "es"
      ? "https://chat.whatsapp.com/JeFFLr7IVIQIHkjgp8DwKQ?mode=gi_t"
      : "https://chat.whatsapp.com/BdTImDgFZfqEns7EaxWmiS?mode=gi_t";

  return (
    <div className="fixed bottom-24 md:bottom-8 right-4 md:right-6 z-40">
      {/* Tooltip Bubble */}
      <div
        className={`absolute bottom-full right-1/2 translate-x-1/2 mb-3 transition-all duration-500 ${
          showTooltip ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
        }`}
      >
        <div className="bg-white text-foreground px-4 py-2 rounded-xl shadow-lg whitespace-nowrap text-sm font-bold border border-border">
          {t("whatsapp_button.tooltip")}
        </div>
        {/* Arrow */}
        <div className="absolute top-full right-1/2 translate-x-1/2 -mt-1">
          <div className="w-3 h-3 bg-white border-r border-b border-border rotate-45 -translate-y-1.5"></div>
        </div>
      </div>

      {/* WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact us on WhatsApp"
        className={`relative flex items-center justify-center h-[60px] w-[60px] rounded-full bg-[#25D366] shadow-lg hover:scale-110 transition-transform duration-300 ${
          isPulsing ? "animate-bounce-gentle" : ""
        }`}
        style={{ boxShadow: "0 4px 20px rgba(37, 211, 102, 0.4)" }}
      >
        {/* Pulse Animation Ring */}
        <span 
          className={`absolute inset-0 rounded-full bg-[#25D366] transition-all duration-500 ${
            isPulsing ? "animate-ping opacity-40" : "opacity-0"
          }`}
        />
        
        {/* WhatsApp Icon */}
        <svg
          className="h-8 w-8 text-white relative z-10"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>
    </div>
  );
};
